import mrpStyles from './../mrp.json'

export default {
  paginatorPosition: 'top',
  paginatorColor: mrpStyles.colors.PrimaryWhite,
  paginatorBottomSpacing: 16,
  paginatorTopSpacing: 0
}
